import { KYMW1309Component } from './kymw1309.component';
import { isArray } from 'util';
import { KYMW1308PromotionGoodsInfoModel } from '../kymw1308/vo/kymw1308-promotion-goods-info.model';

/**
 * バンドルミックスマッチ検索画面の値を管理するクラス
 *
 * @export KYMW1309Model
 * @class KYMW1309Model
 */
export class KYMW1309Model {

  kymw1309Component: KYMW1309Component;

  private readonly FLAG_ON: string = '1';

  // 画面項目バインド値
  // プロモーション区分
  public promotionDiv: string = <string>'';

  // 生協
  public coop: string = <string>'';

  // 部門コード
  public classCode: string = <string>'';

  // プロモーション名称
  public promotionName: string = <string>'';

  // Pコード
  public pCode: string = <string>'';

  // プロモーション情報
  public promotionInfo: Array<any> = new Array<any>();

  // 内部保持情報
  // 受注コード
  public orderCode: string = <string>'';

  // 媒体区分
  public mediumType: string = <string>'';

  /**
   * サーバ取得データを反映する
   *
   * @param serverData サーバ取得データ
   */
  public updateKYMW1309 ( serverData: any ): void {

    if ( serverData == null ) {
      this.promotionInfo = new Array<any>();
      return;
    }

    this.promotionInfo = new Array<any>();

    if ( isArray(serverData) ) {
      for ( let i = Number(0); i < serverData.length; i++ ) {
        this.promotionInfo.push( this.getPromotionGoodsInfoVO( serverData[i] ));
      }
    } else {
      this.promotionInfo.push( this.getPromotionGoodsInfoVO( serverData ));
    }

    // フォーカス設定
    this.kymw1309Component.btn_Search.nativeElement.focus();
  }

  /* プロモーション情報一覧を作成 */
  private getPromotionGoodsInfoVO( data: any ): KYMW1308PromotionGoodsInfoModel {

    const vo: KYMW1308PromotionGoodsInfoModel = new KYMW1308PromotionGoodsInfoModel();

    // プロモーションＮＯ
    vo.promotionNo = data.PromotionNo;

    // プロモーション名称
    vo.promotionName = data.PromotionName;

    // プロモーション区分
    vo.promotionDivName = data.PromotionDivName;

    // Ｐコード
    vo.pCode = data.PCode;

    // 商品案内用商品名
    vo.guideGoodsName = data.GuideGoodsName;

    // 商品案内用規格名
    vo.guideStandardName = data.GuideStandardName;

    // 取扱フラグ（いばらき）
    if ( data.HandlingFlgIB === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceIB = data.ThisTimeSupplyPriceIB;

      // 仕入価格
      vo.thisTimeCostPriceIB = data.ThisTimeCostPriceIB;

      // プロモーションフラグ（いばらき）
      if ( data.PromotionFlgIB === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumIB = data.ApprovedNumIB;

        // 成立価格
        vo.approvedPriceIB = data.ApprovedPriceIB;

        // わくわくポイント
        vo.wakuwakuPointIB = data.WakuwakuPointIB;
      }
    }

    // 取扱フラグ（とちぎ）
    if ( data.HandlingFlgTO === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceTO = data.ThisTimeSupplyPriceTO;

      // 仕入価格
      vo.thisTimeCostPriceTO = data.ThisTimeCostPriceTO;

      // プロモーションフラグ（いばらき）
      if ( data.PromotionFlgTO === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumTO = data.ApprovedNumTO;

        // 成立価格
        vo.approvedPriceTO = data.ApprovedPriceTO;

        // わくわくポイント
        vo.wakuwakuPointTO = data.WakuwakuPointTO;
      }
    }

    // 取扱フラグ（ぐんま）
    if ( data.HandlingFlgGU === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceGU = data.ThisTimeSupplyPriceGU;

      // 仕入価格
      vo.thisTimeCostPriceGU = data.ThisTimeCostPriceGU;

      // プロモーションフラグ（いばらき）
      if ( data.PromotionFlgGU === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumGU = data.ApprovedNumGU;

        // 成立価格
        vo.approvedPriceGU = data.ApprovedPriceGU;

        // わくわくポイント
        vo.wakuwakuPointGU = data.WakuwakuPointGU;
      }
    }

    // 取扱フラグ（ちば）
    if ( data.HandlingFlgTI === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceTI = data.ThisTimeSupplyPriceTI;

      // 仕入価格
      vo.thisTimeCostPriceTI = data.ThisTimeCostPriceTI;

      // プロモーションフラグ（いばらき）
      if ( data.PromotionFlgTI === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumTI = data.ApprovedNumTI;

        // 成立価格
        vo.approvedPriceTI = data.ApprovedPriceTI;

        // わくわくポイント
        vo.wakuwakuPointTI = data.WakuwakuPointTI;
      }
    }

    // 取扱フラグ（さいたま）
    if ( data.HandlingFlgSA === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceSA = data.ThisTimeSupplyPriceSA;

      // 仕入価格
      vo.thisTimeCostPriceSA = data.ThisTimeCostPriceSA;

      // プロモーションフラグ（いばらき）
      if ( data.PromotionFlgSA === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumSA = data.ApprovedNumSA;

        // 成立価格
        vo.approvedPriceSA = data.ApprovedPriceSA;

        // わくわくポイント
        vo.wakuwakuPointSA = data.WakuwakuPointSA;
      }
    }

    // 取扱フラグ（とうきょう）
    if ( data.HandlingFlgTK === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceTK = data.ThisTimeSupplyPriceTK;

      // 仕入価格
      vo.thisTimeCostPriceTK = data.ThisTimeCostPriceTK;

      // プロモーションフラグ（いばらき）
      if ( data.PromotionFlgTK === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumTK = data.ApprovedNumTK;

        // 成立価格
        vo.approvedPriceTK = data.ApprovedPriceTK;

        // わくわくポイント
        vo.wakuwakuPointTK = data.WakuwakuPointTK;
      }
    }

    // 取扱フラグ（ながの）
    if ( data.HandlingFlgNA === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceNA = data.ThisTimeSupplyPriceNA;

      // 仕入価格
      vo.thisTimeCostPriceNA = data.ThisTimeCostPriceNA;

      // プロモーションフラグ（いばらき）
      if ( data.PromotionFlgNA === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumNA = data.ApprovedNumNA;

        // 成立価格
        vo.approvedPriceNA = data.ApprovedPriceNA;

        // わくわくポイント
        vo.wakuwakuPointNA = data.WakuwakuPointNA;
      }
    }

    // 取扱フラグ（にいがた）
    if ( data.HandlingFlgNI === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceNI = data.ThisTimeSupplyPriceNI;

      // 仕入価格
      vo.thisTimeCostPriceNI = data.ThisTimeCostPriceNI;

      // プロモーションフラグ（いばらき）
      if ( data.PromotionFlgNI === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumNI = data.ApprovedNumNI;

        // 成立価格
        vo.approvedPriceNI = data.ApprovedPriceNI;

        // わくわくポイント
        vo.wakuwakuPointNI = data.WakuwakuPointNI;
      }
    }

    // 取扱フラグ（クルコ）
    if ( data.HandlingFlgKU === this.FLAG_ON ) {

      // 供給価格（税込）
      vo.thisTimeSupplyPriceKU = data.ThisTimeSupplyPriceKU;

      // 仕入価格
      vo.thisTimeCostPriceKU = data.ThisTimeCostPriceKU;

      // プロモーションフラグ（クルコ）
      if ( data.PromotionFlgKU === this.FLAG_ON ) {

        // 成立数量
        vo.approvedNumKU = data.ApprovedNumKU;

        // 成立価格
        vo.approvedPriceKU = data.ApprovedPriceKU;

        // わくわくポイント
        vo.wakuwakuPointKU = data.WakuwakuPointKU;
      }
    }

    return vo;
  }
}
